import { Button, Input, message, DatePicker, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { calendarIcon } from '@/constants/static';
import { disabledDateValidity, handleExportCodes, numberInput, scrollInto } from '@/utils/publicMethod';
import dayjs from 'dayjs';
import couponApi from '@/api/coupon';
import useBack from './useBackPre';
import format from '@/utils/format';
import { useDispatch, useSelector } from 'react-redux';
import { setvoucherCodeId } from '@/store/stateSlice';
interface VoucherParams {
    voucherName: string;
    description: string;
    validityType: number; // 有效期类型
    validityDays: string | number; // 有效天数
    beginDate: string;
    endDate: string;
    isFixedCode: boolean | null;
    discountCode: string; //固定折扣码
    maxQuantity: string | number;
    isUnlimited: boolean | null;
    quantity: string | number;
    discountType: number;
    minTask: string | number;
    discount: string | number; // 固定折扣金额 or 折扣百分比
}
const { RangePicker } = DatePicker;
const validityTypes = ['permanentlyValid', 'validityPeriod', 'validityDays'];
const discountTypes = ['fixedAmount', 'percentage', 'noFees'];

const VoucherCodeInfo = () => {
    const [state, setState] = useState<VoucherParams>({
        voucherName: '',
        description: '',
        validityType: -1,
        validityDays: '',
        beginDate: '',
        endDate: '',
        isFixedCode: null,
        discountCode: '', //固定折扣码
        maxQuantity: '',
        isUnlimited: null,
        quantity: '',
        discountType: -1,
        minTask: '',
        discount: '',
    });
    const { onBack } = useBack('VoucherCodes');
    // modal
    const [createStatus, setCreateStatus] = useState({ creating: false, id: '' });
    const [tipModal, setTipModal] = useState(false);
    const [createing, setCreateing] = useState<'' | 'random' | 'default'>('');
    const create = async () => {
        const {
            voucherName,
            description,
            isFixedCode,
            discountCode,
            maxQuantity,
            quantity,
            validityDays,
            validityType,
            beginDate,
            endDate,
            discountType,
            minTask,
            discount,
            isUnlimited,
        } = state;
        if (isFixedCode === null) {
            scrollInto('', 'quantity-input');
            message.error('Please complete all required information.');
            console.log('未选择随机码类型');
            return;
        }
        if (!isFixedCode && !quantity) {
            setErrorStyle('', 'quantity-input');
            console.log('未填写随机码数量');
            return;
        }
        if (isFixedCode) {
            if (!discountCode || discountCode.length < 6) {
                setErrorStyle('', 'discount-code', true, 'Please enter a 6-12 digit custom discount code');
                console.log('未填写固定折扣码');
                return;
            }
            if (isUnlimited === null) {
                scrollInto('', 'max-quantity');
                message.error('Please complete all required information.');
                console.log('未选择固定码数量类型');
                return;
            }
            if (!isUnlimited && !maxQuantity) {
                setErrorStyle('', 'max-quantity');
                console.log('未填写固定折扣最大数量');
                return;
            }
        }
        if (discountType === -1) {
            scrollInto('', 'min-task');
            message.error('Please complete all required information.');
            console.log('未选择优惠券类型');
            return;
        }
        if (discountType < 2) {
            if (!minTask || Number(minTask) === 0) {
                setErrorStyle('', 'min-task');
                console.log('未填写正确的min-task信息');
                return;
            }
            if (!discount || Number(discount) === 0) {
                setErrorStyle('', 'discount-value');
                console.log('未填写正确的discount信息');
                return;
            }
        }
        if (validityType === -1) {
            scrollInto('', 'validity-date');
            message.error('Please complete all required information.');
            console.log('未选择过期类型');
            return;
        }
        // 未选择过期时间
        if (validityType === 1 && (!beginDate || !endDate)) {
            setErrorStyle('', 'validity-date');
            console.log('未选择过期时间');
            return;
        }
        // 未选择过期天数
        if (validityType === 2 && !validityDays) {
            setErrorStyle('', 'validity-days');
            console.log('未选择过期天数');
            return;
        }
        const params: any = {
            voucherName,
            description: description.substring(0, 500),
            validityType: validityTypes[validityType],
            isFixedCode,
            discountType: discountTypes[discountType],
        };
        if (isFixedCode) {
            params.discountCode = discountCode;
            params.isUnlimited = isUnlimited;
            params.quantity = maxQuantity;
        } else {
            params.quantity = quantity;
        }
        if (discountType < 2) {
            params.minTask = Number(minTask) * 100;
            if (!discountType) {
                params.fixedDiscount = Number(discount) * 100;
            } else {
                params.percentageDiscount = Number(discount);
            }
        }
        if (validityType === 1) {
            params.beginDate = beginDate;
            params.endDate = endDate;
        }
        if (validityType === 2) {
            params.validityDays = validityDays;
        }
        console.log('params', params);
        setCreateing(isFixedCode ? 'default' : 'random');
        !isFixedCode && setCreateStatus({ creating: true, id: '' });
        try {
            const res = await couponApi.createVoucherCoupon(params);
            if (isFixedCode) {
                onBack();
            } else {
                setCreateStatus({ creating: true, id: res.data });
            }
        } catch (error: any) {
            message.error(error);
            setCreateing('');
            setCreateStatus({ creating: false, id: '' });
        }
    };
    const setErrorStyle = (
        id?: string,
        className?: string,
        add = true,
        customMsg = 'Please complete all required information.'
    ) => {
        if (id) {
            const el = document.getElementById(id);
            el && (add ? el.classList.add('error-input') : el.classList.remove('error-input'));
        }
        if (className) {
            const el = document.getElementsByClassName(className);
            el.length && (add ? el[0].classList.add('error-input') : el[0].classList.remove('error-input'));
        }
        if (add) {
            message.error(customMsg);
            scrollInto(id, className || '');
        }
    };
    const { voucherCodeId } = useSelector((state: any) => state.state);
    const dispatch = useDispatch();
    useEffect(() => {
        console.log(voucherCodeId, createStatus);
        if (createStatus.id && voucherCodeId === createStatus.id) {
            setCreateStatus({ creating: false, id: createStatus.id });
            dispatch(setvoucherCodeId(''));
        }
    }, [voucherCodeId, createStatus]);
    return (
        <div className="page-main add-coupon">
            {createing === 'default' && <div className="add-coupon-mask"></div>}
            <div className="page-title">
                <img
                    className="back-icon"
                    src={require('@/assets/images/back-icon.png')}
                    alt="back-icon"
                    onClick={() => onBack(false)}
                />
                Create New Voucher Code
            </div>
            <div className="add-coupon-form">
                <div>
                    <div className="coupon-tip">Title</div>
                    <Input
                        showCount={format.countFormatter}
                        className="default_input"
                        placeholder="Title"
                        onInput={(e: any) => setState({ ...state, voucherName: e.target.value })}
                        maxLength={25}
                    />
                </div>
                <div>
                    <div className="coupon-tip">Description</div>
                    <Input.TextArea
                        className="category-notes"
                        maxLength={500}
                        showCount={format.countFormatter}
                        onInput={(e: any) => setState({ ...state, description: e.target.value })}
                        autoSize={{ minRows: 6 }}
                        placeholder="Description"
                    />
                </div>
                <div>
                    <div className="coupon-tip">Is it a fixed discount code?</div>
                    <div className="flex-left bg-item">
                        <div
                            className={`sel-item-box flex-left ${state.isFixedCode === false ? 'checked' : ''}`}
                            onClick={() =>
                                setState({ ...state, isFixedCode: false, discountCode: '', isUnlimited: null })
                            }
                        >
                            <i className="radio-icon"></i>
                            No
                        </div>
                        <Input
                            className="default_input no-border quantity-input"
                            placeholder="Enter code quantity"
                            maxLength={25}
                            disabled={state.isFixedCode || state.isFixedCode === null}
                            onInput={(e: any) => {
                                const value = numberInput(e.target.value, 999999, false, 1);
                                e.target.value = value;
                                setState({ ...state, quantity: value });
                            }}
                            onBlur={() => setErrorStyle('', 'quantity-input', false)}
                        />
                    </div>
                    <div className="bg-item" style={{ marginTop: 24 }}>
                        <div
                            className={`sel-item-box flex-left ${state.isFixedCode ? 'checked' : ''}`}
                            onClick={() => setState({ ...state, isFixedCode: true })}
                        >
                            <i className="radio-icon"></i>
                            Yes
                        </div>
                        <div>
                            <div className="coupon-tip">Custom discount code</div>
                            <div>
                                <Input
                                    className="default_input no-border discount-code"
                                    placeholder="Enter a 6–12 character code"
                                    maxLength={12}
                                    disabled={!state.isFixedCode || state.isFixedCode === null}
                                    onInput={(e: any) => {
                                        const value = e.target.value.replace(/[^A-Za-z0-9]/g, '').toLocaleUpperCase();
                                        e.target.value = value;
                                        setState({ ...state, discountCode: value });
                                    }}
                                    onBlur={() => setErrorStyle('', 'discount-code', false)}
                                />
                            </div>
                            <div className="coupon-tip">Issue quantity</div>
                            <div
                                className={`sel-item-box flex-left ${state.isUnlimited ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, isUnlimited: true })}
                            >
                                <i className="radio-icon"></i>
                                Unlimited
                            </div>
                            <div className="flex-left" style={{ marginTop: 24 }}>
                                <div
                                    className={`sel-item-box flex-left ${
                                        !state.isUnlimited && state.isUnlimited !== null ? 'checked' : ''
                                    }`}
                                    onClick={() => setState({ ...state, isUnlimited: false })}
                                >
                                    <i className="radio-icon"></i>
                                    Limit the maximum exchange quantity
                                </div>
                                <Input
                                    className="default_input no-border max-quantity"
                                    placeholder="Maximum exchange quantity"
                                    maxLength={10}
                                    disabled={!state.isFixedCode}
                                    onInput={(e: any) => {
                                        const value = numberInput(e.target.value, 999999, false, 1);
                                        e.target.value = value;
                                        setState({ ...state, maxQuantity: value });
                                    }}
                                    onBlur={() => setErrorStyle('', 'max-quantity', false)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="coupon-tip">Discount</div>
                    <div className="bg-item">
                        <div className="flex-left ">
                            {[
                                { label: 'Fixed discount amount', key: 0 },
                                { label: 'Percentage discount', key: 1 },
                                { label: 'No-Fees', key: 2 },
                            ].map(i => {
                                return (
                                    <div
                                        key={i.label}
                                        className={`sel-item-box flex-left marr24 ${
                                            state.discountType == i.key ? 'checked' : ''
                                        }`}
                                        onClick={() => setState({ ...state, discountType: i.key })}
                                    >
                                        <i className="radio-icon"></i>
                                        {i.label}
                                    </div>
                                );
                            })}
                        </div>
                        {state.discountType < 2 && state.discountType !== -1 && (
                            <div className="flex-left" style={{ marginTop: 24, width: 632 }}>
                                <div className="flex-left flex1">
                                    <span className="discount-c-tip">Min Task</span>
                                    <Input
                                        className="default_input no-border min-task"
                                        placeholder=""
                                        maxLength={25}
                                        prefix="$"
                                        onInput={(e: any) => {
                                            const value = numberInput(e.target.value);
                                            e.target.value = value;
                                            setState({ ...state, minTask: value });
                                        }}
                                    />
                                </div>
                                <div className="flex-left flex1" style={{ marginLeft: 24 }}>
                                    <span className="discount-c-tip">Discount</span>
                                    <Input
                                        className="default_input no-border discount-value"
                                        placeholder=""
                                        maxLength={25}
                                        prefix={!state.discountType ? '$' : ''}
                                        suffix={state.discountType === 1 ? '%' : ''}
                                        onInput={(e: any) => {
                                            const value = numberInput(
                                                e.target.value,
                                                !state.discountType ? 99999 : 100,
                                                false
                                            );
                                            e.target.value = value;
                                            setState({ ...state, discount: value });
                                        }}
                                        onBlur={e => {
                                            const value = e.target.value;
                                            if (state.discountType === 1 && Number(value) >= 20) {
                                                setTipModal(true);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div>
                    <div className="coupon-tip">Validity period</div>
                    <div>
                        <div>
                            <div
                                className={`sel-item-box flex-left marr24 ${!state.validityType ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, validityType: 0 })}
                            >
                                <i className="radio-icon"></i>
                                Permanently valid
                            </div>
                        </div>
                        <div className="flex-left select-bar" style={{ margin: '24px 0' }}>
                            <div
                                className={`sel-item-box flex-left marr24 ${state.validityType === 1 ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, validityType: 1 })}
                            >
                                <i className="radio-icon"></i>
                                Validity period
                            </div>
                            <RangePicker
                                style={{ width: 290 }}
                                className="search-input validity-date"
                                placeholder={['dd/mm/yyyy', 'dd/mm/yyyy']}
                                suffixIcon={calendarIcon}
                                separator={'-'}
                                format={'DD/MM/YYYY'}
                                disabledDate={disabledDateValidity}
                                onChange={val => {
                                    const beginDate = val
                                        ? dayjs(`${dayjs(val[0]).format('YYYY-MM-DD')} 00:00:00`).toISOString()
                                        : '';
                                    const endDate = val
                                        ? dayjs(`${dayjs(val[1]).format('YYYY-MM-DD')} 23:59:59`).toISOString()
                                        : '';
                                    setState({ ...state, beginDate, endDate });
                                }}
                            />
                        </div>
                        <div className="flex-left">
                            <div
                                className={`sel-item-box flex-left marr24 ${state.validityType === 2 ? 'checked' : ''}`}
                                onClick={() => setState({ ...state, validityType: 2 })}
                            >
                                <i className="radio-icon"></i>
                                Validity days limit
                            </div>
                            <Input
                                style={{ width: 154 }}
                                className="default_input no-border validity-days"
                                placeholder=""
                                maxLength={25}
                                suffix="Day(s)"
                                onInput={(e: any) => {
                                    const value = numberInput(e.target.value, 999, false, 1);
                                    e.target.value = value;
                                    setState({ ...state, validityDays: value });
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div>
                    <div style={{ display: 'flex', marginTop: 24, columnGap: 12 }}>
                        <Button style={{ width: 132 }} onClick={() => onBack(false)} className="cancel-btn bg-f5">
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            onClick={create}
                            style={{ width: 194 }}
                            loading={createing === 'default'}
                            disabled={!state.voucherName || !state.description}
                        >
                            Create
                        </Button>
                    </div>
                </div>
            </div>
            {/* loading modal */}
            <Modal width={440} maskClosable={false} centered={true} open={createStatus.creating} closeIcon={<></>}>
                <div className="flex-center">
                    <i className="loading-icon spin"></i>
                </div>
                <div className="modal-tip tip-font-16" style={{ marginBottom: 0 }}>
                    Generating promo codes...
                </div>
                <div style={{ marginTop: '40px', textAlign: 'center' }}>
                    <Button type="primary" onClick={() => onBack()}>
                        Skip & Download Later
                    </Button>
                </div>
            </Modal>
            {/* success modal */}
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={!createStatus.creating && createStatus.id !== ''}
                closeIcon={<></>}
            >
                <div className="modal-title" style={{ marginTop: 0 }}>
                    Codes generated
                </div>
                <div className="modal-tip tip-font-16" style={{ margin: '8px 0 0 0' }}>
                    {state.isFixedCode ? state.maxQuantity : state.quantity} codes have been generated. <br></br>
                    Would you like to export them to a CSV file?
                </div>
                <div className="flex-center" style={{ marginTop: 40, columnGap: 12 }}>
                    <Button style={{ width: 138, height: 46 }} onClick={() => onBack()} className="cancel-btn">
                        Cancel
                    </Button>
                    <Button
                        style={{ width: 138, height: 46 }}
                        type="primary"
                        onClick={() => handleExportCodes(createStatus.id, state.voucherName, () => onBack())}
                    >
                        Download CSV
                    </Button>
                </div>
            </Modal>
            {/* tip modal */}
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={tipModal}
                onCancel={() => setTipModal(false)}
                closeIcon={<></>}
            >
                <div className="modal-title" style={{ marginTop: 0 }}>
                    Heads Up!
                </div>
                <div className="modal-tip tip-font-16" style={{ margin: '8px 0 0 0' }}>
                    Setting a high discount rate for your coupon may result in additional costs that the platform will
                    need to cover. <br></br>
                    We recommend reviewing the discount amount to avoid unintended platform charges.
                </div>
                <div className="flex-center" style={{ marginTop: 40 }}>
                    <Button style={{ width: 138, height: 46 }} type="primary" onClick={() => setTipModal(false)}>
                        Ok
                    </Button>
                </div>
            </Modal>
        </div>
    );
};
export default VoucherCodeInfo;
